import { RadioButton, Text, Flex } from '@libs/ui/ds' // Corrected import path
import { ControllerBase } from '@libs/ui/form'
import type { FieldValues, FieldPath } from 'react-hook-form'

import type {
  ControlledRadioGroupProps,
  RadioGroupOption
} from './ControlledRadioGroup.types'

export const ControlledRadioGroup = <
  TFieldValues extends FieldValues = FieldValues,
  TInputName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  control,
  rules,
  label,
  options,
  radioGroupProps,
  required,
  errorMessage,
  onChangeSideEffect
}: ControlledRadioGroupProps<TFieldValues, TInputName>) => (
  <Flex className='flex-col'>
    <Text className='text-s font-medium text-neutral-800'>
      {label}
      {required && (
        <span className='ml-1 text-xs font-semibold leading-4 text-semantic-red-400'>
          *
        </span>
      )}
    </Text>
    <ControllerBase
      rules={rules}
      control={control}
      name={name}
      field={
        <RadioButton.Group
          {...radioGroupProps}
          required={required}
          errorMessage={errorMessage}
        >
          {options.map((option: RadioGroupOption) => (
            <RadioButton
              key={option.value}
              value={option.value}
              label={option.label}
              position='right'
              {...option.radioButtonProps}
            />
          ))}
        </RadioButton.Group>
      }
      onChangeAdapter={e => e}
      onChangeSideEffect={onChangeSideEffect}
    />
  </Flex>
)
